import { useEffect, useState } from "react";
import { MessageSquare } from "lucide-react";
import { api } from "@/lib/api";

// Lines friends have left on my shared folders since I last looked.
export const FolderCommentAlerts = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/news/folders/comments")
      .then(({ data }) => setRows(data.comments))
      .catch(() => {});
  }, []);

  const clear = async () => {
    setRows([]);
    try {
      await api.post("/news/folders/comments/seen");
    } catch (e) {
      console.error("could not clear the folder notes", e);
    }
  };

  if (rows.length === 0) return null;

  return (
    <div className="mt-6 rounded-3xl border border-brand/40 bg-brand/10 p-5"
         data-testid="folder-comment-alerts">
      <p className="flex items-center gap-2 text-sm font-semibold">
        <MessageSquare className="h-4 w-4 text-brand" /> On your shared folders
        <span className="ms-1 rounded-full bg-brand px-2 py-0.5 text-[10px] font-bold text-white">
          {rows.length}
        </span>
      </p>
      <ul className="mt-2 space-y-1.5">
        {rows.map((row) => (
          <li key={row.comment_id} className="text-sm" dir="auto"
              data-testid={`folder-note-${row.comment_id}`}>
            <span className="font-semibold text-brand">{row.name}</span>
            <span className="text-ink-soft">{` on “${row.folder}” · `}</span>
            {row.text}
          </li>
        ))}
      </ul>
      <button
        data-testid="folder-comments-seen"
        onClick={clear}
        className="mt-3 inline-flex min-h-[34px] items-center rounded-full border border-brand/50 px-4 text-xs font-semibold text-brand transition-colors hover:bg-brand/10"
      >
        Got it
      </button>
    </div>
  );
};
